var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenafiLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 280,
    viewBox: "0 0 600 280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(255, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -50,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -50,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -50,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: -50,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -32,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -32,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -32,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: -32,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -14,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -14,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -14,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: -14,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: 4,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: 4,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: 22,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 16,
    height: 13,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    x1: -38,
    y1: 38,
    x2: 36,
    y2: 38,
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -15,
    width: 18,
    height: 15,
    rx: 4,
    fill: "#EF9F27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -18,
    width: 24,
    height: 21,
    rx: 6,
    fill: "none",
    stroke: "#EF9F27",
    strokeWidth: 0.6,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,-7.5 C26,-7.5 26,-36 35,-36 C44,-36 44,20 53,20 C62,20 62,-28 71,-28 C80,-28 80,-7.5 86,-7.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,-7.5 L126,-7.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: -7.5,
    r: 3,
    fill: "#ffffff",
    opacity: 0.4
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Helvetica Neue', 'Arial', sans-serif",
    fontSize: 34,
    fontWeight: 500,
    fill: "#ffffff",
    x: 300,
    y: 185,
    textAnchor: "middle",
    letterSpacing: 13
  }, "TENAFI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Helvetica Neue', 'Arial', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.55)",
    x: 300,
    y: 208,
    textAnchor: "middle",
    letterSpacing: 2.5
  }, "Predict \xB7 Act \xB7 Collect")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenafiLoginLogo);
export default __webpack_public_path__ + "static/media/tenafi-login-logo.cc45727ea27fbed33d668c36938bf164.svg";
export { ForwardRef as ReactComponent };